import { Component } from '@angular/core';
import { RiskConceptsComponent } from '../risk-concepts/risk-concepts.component';
@Component({selector:'app-trade-tickets',standalone:true,imports:[RiskConceptsComponent],template:'<app-risk-concepts [page]="2"></app-risk-concepts>'})
export class TradeTicketsComponent {}
